// extracted by mini-css-extract-plugin
export var skipAnimation = "_44-0";